<div class="home-container">
    <app-header></app-header>
    <router-outlet></router-outlet>
</div>